var App = App || {};

var nodePath;
let selectedTopic = null;
let selectedContentType = null;
let searchTerm = null;
var $VideoListSlider;
var pagetopic;
var pagecontent;

App.VideoList = (function ($) {
    'use strict';

    
    function init() {

        nodePath = $('#videolistnodeAliasPath').val();
        updateComponentJQuery(true);

        $(document).on('click', '.videopage-link', function (e) {
            e.preventDefault();
            const categoryId = $(this).data('id');
            const page = $(this).data('page');
            updateComponentJQuery(false, categoryId, page);
        });

        $(document).on('click', '#topic-dropdown .dropdown-item', function () {
           selectedTopic = $(this).data('name');
            $('#topic-filter .dropdown-toggle .text').text($(this).text());
            fetchFilteredData(selectedTopic, selectedContentType, searchTerm);
        });

        $(document).on('click', '#content-type-dropdown .dropdown-item', function () {
            selectedContentType = $(this).data('name');
            $('#content-type-filter .dropdown-toggle .text').text($(this).text());
            fetchFilteredData(selectedTopic, selectedContentType, searchTerm);
        });

        $('#VideoControls_Search').on('submit', function (e) {
            e.preventDefault();
             searchTerm = $(this).find('input[name="SearchTerm"]').val().trim();
            fetchFilteredData(selectedTopic, selectedContentType, searchTerm);
        });

        var $videoContainer = $('#videoContainer');
        var $transcriptContainer = $('.component-iframe-transcript');
        var videoData = { type: '', url: '' };

        $(document).on('click', '.open-video-modal', function (e) {
            e.preventDefault();

            videoData.type = $(this).data('type');
            videoData.url = $(this).data('video');
            videoData.transcript = $(this).data('transcript');
            videoData.title = $(this).data('title');

            $('#videolistModal').modal('show');
        });

        $('#videolistModal').on('shown.bs.modal', function () {
            var content = '';

            if (videoData.type === 'iframe') {

             
               
                content = `<iframe src="${videoData.url}" frameborder="0" allowtransparency="true" scrolling="no" allowfullscreen="" mozallowfullscreen=""  webkitallowfullscreen="" oallowfullscreen="" msallowfullscreen="" allow="fullscreen"></iframe>`;
            } else if (videoData.type === 'video') {
               
                content = `
            <video controls autoplay muted playsinline class="w-100 h-100">
              <source src="${videoData.url}" type="video/mp4">
              Your browser does not support the video tag.
            </video>`;
            }

            $videoContainer.html(content);

          
            if (videoData.transcript) {
                $transcriptContainer.html(`<a href="${videoData.transcript}" target="_blank" aria-label="Click to open a transcript of ${videoData.title}">
              Transcript
              </a>`);
            } else {
                $transcriptContainer.empty();
            }
        });


        $('#videolistModal').on('hidden.bs.modal', function () {
            $videoContainer.empty();
        });


        setupFlickityPrototypeOnce(); 


        
    }

    function updateComponentJQuery(isFirst, categoryId = null, page = null, topic = null, contentType = null, search = null) {
        nodePath = $('#videolistnodeAliasPath').val();
        pagetopic = $('#pageTopics').val();
        pagecontent = $('#pageContentTypes').val();

        if (isFirst) {
            $.getJSON(`/api/VideoList/GetTypes?nodeAliasPath=${encodeURIComponent(nodePath)}&pageTopic=${encodeURIComponent(pagetopic)}&pageContent=${encodeURIComponent(pagecontent)}`, function (types) {
                

              
                if (types.topics?.length > 0 && types.showTopic) {
                    const $topicDropdown = $('#topic-dropdown');
                    $topicDropdown.empty();

                    const $defaultItem = $('<li><a href="javascript:void(0);" class="dropdown-item" data-name="">All Topics</a></li>');
                    $topicDropdown.append($defaultItem);
                    types.topics.forEach(function (topic) {
                        const $item = $('<li><a href="javascript:void(0);" class="dropdown-item" data-name="' + topic.displayName + '">' + topic.displayName + '</a></li>');
                        $topicDropdown.append($item);
                    });
                    $('#topic-filter').removeClass('d-none');
                }

                
                if (types.contentTypes?.length > 0 && types.showContentType) {
                    const $contentTypeDropdown = $('#content-type-dropdown');
                    $contentTypeDropdown.empty();

                    const $defaultContentItem = $('<li><a href="javascript:void(0);" class="dropdown-item" data-name="">All Content Types</a></li>');
                    $contentTypeDropdown.append($defaultContentItem);
                    types.contentTypes.forEach(function (type) {
                        const $item = $('<li><a href="javascript:void(0);" class="dropdown-item" data-name="' + type.displayName + '">' + type.displayName + '</a></li>');
                        $contentTypeDropdown.append($item);
                    });
                    $('#content-type-filter').removeClass('d-none');
                }

                if (types.showSearch) {
                    $('.blog-navigation-controls-search').removeClass('d-none');
                }
            });
        }

        let params = {
            nodeAliasPath: nodePath
        };

        if (categoryId !== null) params.categoryId = categoryId;
        if (page !== null) params.page = page;
        if (topic !== null) params.topic = topic;
        if (contentType !== null) params.contentType = contentType;
        if (search !== null) params.search = search;

        const queryString = $.param(params);
      

        $.getJSON('/Api/VideoList/GetVideos?' + queryString)
            .done(function (videosJson) {
               
                renderVideos(videosJson, categoryId, page);
                renderMobileVideos(videosJson);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.error('Error fetching videos:', errorThrown);
            });
    }

   
   

    function renderVideos(videos, categoryId, page) {
      
        const allCategories = videos.allCategories || [];
        const categoriesWithVideos = videos.categories || [];

        const isPagination = categoryId !== null && page !== null;

        if (isPagination) {
           
            const category = categoriesWithVideos.find(cat => cat.id === categoryId);
            if (category) {
                const newHtml = renderCategoryHtml(category);
                const existingWrapper = $(`#category-wrapper-${category.id}`);
                if (existingWrapper.length) {
                    existingWrapper.replaceWith(newHtml);
                } else {
                    $('#video-render-container').append(newHtml);
                }
            }
            
            return;
        }

         const categoryIdsWithVideos = new Set(
            Array.isArray(categoriesWithVideos) ? categoriesWithVideos.map(cat => cat.id) : []
        );
   


        
        allCategories.forEach(cat => {
            if (!categoryIdsWithVideos.has(cat.id)) {
                $(`#category-wrapper-${cat.id}`).remove(); 
            }
        });

       
        categoriesWithVideos.forEach(category => {
            const newHtml = renderCategoryHtml(category);

            if (newHtml.trim() !== '') {
                const existingWrapper = $(`#category-wrapper-${category.id}`);
                if (existingWrapper.length) {
                    existingWrapper.replaceWith(newHtml);
                } else {
                    $('#video-render-container').append(newHtml);
                }
            }
        });

       
        if (categoriesWithVideos.length === 0) {
            if (!$('#category-wrapper-noresults').length) {
                const noResultsHtml = `
                <div id="category-wrapper-noresults">
                    <div class="blog-posts-lists paginated blog-video-wrapper-desktop d-none d-lg-block">
                        <div class="container">
                            <div class="blog-posts-lists-layout">
                                <div class="blog-posts-lists-no-results">
                                    <div>Sorry, we couldn't find what you were looking for. Please try your search again.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`;
                $('#video-render-container').append(noResultsHtml);
            }
        } else {
            $('#category-wrapper-noresults').remove();
        }
    }


 
    

    function renderCategoryHtml(category) {
        let html = '';

        html += `
    <div id="category-wrapper-${category.id}">
        <div class="blog-posts-lists paginated blog-video-wrapper-desktop d-none d-lg-block">
            <div class="container">
                <div class="blog-posts-lists-layout">
                    <h3 class="mb-3 category-title">${category.categoryName}</h3>
                    <div class="blog-posts-lists-items">
    `;

        $.each(category.pagedVideos, function (j, video) {

            const isNewTab = video.showVideo === "newtab";
            const isMedia = video.videoType === "media";
            const isEmbed = video.videoType === "embed";

            const videoHref = isNewTab
                ? (isMedia ? video.mediaLibraryVideo : video.videoSource)
                : "javascript:void(0);";

            const videoAttrs = isNewTab
                ? `target="_blank" rel="noopener noreferrer"`
                : `data-type="${isMedia ? "video" : "iframe"}" data-video="${isMedia ? video.mediaLibraryVideo : video.videoSource}" data-transcript="${video.videoTranscript}" data-title="${video.title}"`;

            const videoAriaLabel = isNewTab
                ? `Play video: ${video.title}. Opens in a new tab.`
                : `Play video: ${video.title}. Opens in a modal window.`;

            
            const videoLink = `<a class="item-blog-post-video ${!isNewTab ? 'open-video-modal' : ''}" href="${videoHref}" ${videoAttrs} aria-label="${videoAriaLabel}">`;

           
            const titleLink = `<a class="video-list-title item-blog-post-title ${!isNewTab ? 'open-video-modal' : ''}" href="${videoHref}" ${videoAttrs} aria-label="${videoAriaLabel}">${video.title}</a>`;        

            html += `
        <div class="card-wrapper">
            <div class="item-blog-post item-blog-post-card blog-video-card">
                ${videoLink}
                    <img src="${video.videoImage}" alt="${video.title}" class="img-fluid" />
                </a>
                <div class="item-blog-post-content">
                    <div class="item-blog-post-meta">
                        ${video.time ? `<span class="category">${video.time}</span>` : ''}
                        ${video.date ? `<span>${video.date}</span>` : ''}
                    </div>
                    <div class="item-blog-post-title">                  
                     ${titleLink}                   
                   </div>
                    <div class="item-blog-post-desc video-content">${video.description}</div>
                </div>
            </div>
        </div>`;
        });

        html += `
                </div> <!-- .blog-posts-lists-items -->
                </div> <!-- .blog-posts-lists-layout -->
             `;

        if (category.totalPages > 1) {
            html += `
                <div class="blog-posts-lists-pagination pagination_sm desktop no-promo mt-5">
                    <nav aria-label="Video results pagination">
                        <div class="pagination-container pt-5">
                            <ul class="pagination">
                                <li class="page-item ${category.currentPage === 1 ? 'disabled' : ''}">
                                    <a href="javascript:void(0);" class="page-link videopage-link" data-id="${category.id}" data-page="${category.currentPage - 1}" aria-label="Previous page">
                                        <span class="fa fa-chevron-left"></span>
                                    </a>
                                </li>`;

            for (let p = 1; p <= category.totalPages; p++) {
                html += `
            <li class="page-item ${category.currentPage === p ? 'active' : ''}">
                <a href="javascript:void(0);" class="page-link videopage-link" data-id="${category.id}" data-page="${p}" aria-label="Page ${p} of ${category.totalPages}">${p}</a>
            </li>`;
            }

            html += `
                                <li class="page-item ${category.currentPage === category.totalPages ? 'disabled' : ''}">
                                    <a href="javascript:void(0);" class="page-link videopage-link" data-id="${category.id}" data-page="${category.currentPage + 1}" aria-label="Next page">
                                        <span class="fa fa-chevron-right"></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>`;
        }
        html += `
    <div class="component divider"><hr /></div>
       </div>
       </div>
       </div>`;
                

        return html;
    }

  


    function renderMobileVideos(videos) {
        const container = $('.blog-posts-lists.paginated.mobile.blog-video-wrapper-mobile .container');

        
        container.find('.video-list-mobileitems').each(function () {
            const $slider = $(this);
            if ($slider.data('flickity')) {
                $slider.flickity('destroy');
            }
        });

       
        container.empty();

       
        const categoriesWithVideos = videos.categories?.filter(cat => cat?.allVideos?.length > 0) || [];

        if (categoriesWithVideos.length > 0) {
            categoriesWithVideos.forEach((category) => {
                    const categoryHtml = `
                    <div class="blog-posts-lists-layout mobile blog-video-wrapper-mobile">
                        <h3 class="mb-3 category-title">${category.categoryName}</h3>
                        <div class="blog-posts-lists-items mobile video-list-mobileitems">
                            ${category.allVideos.map(video => `
                                <div class="card-wrapper">
                                    <div class="item-blog-post item-blog-post-card blog-video-card">
                                        ${renderVideoAnchor(video)}
                                        <div class="item-blog-post-content">
                                            <div class="item-blog-post-meta">
                                                ${video.time ? `<span class="category">${video.time}</span>` : ''}
                                                ${video.date ? `<span>${video.date}</span>` : ''}
                                            </div>
                                            <div class="item-blog-post-title">${video.title}</div>
                                            <div class="item-blog-post-desc">${video.description}</div>
                                        </div>
                                    </div>
                                </div>
                            `).join('')}
                        </div>
                    </div>
                    <div class="component divider m-3 py-5"><hr /></div>
                `;
                    container.append(categoryHtml);
                });
        } else {
           
            container.append(`
            <div class="blog-posts-lists-no-results mobile">
                <div>Sorry, we couldn't find what you were looking for. Please try your search again.</div>
            </div>
        `);
        }

       
        initImageCarousel();
        setEqualHeight();       

    }

    function renderVideoAnchor(video) {
        if (video.showVideo === "newtab" && video.videoType === "media") {
            return `<a class="item-blog-post-video" target="_blank" rel="noopener noreferrer" href="${video.mediaLibraryVideo}">
                    <img src="${video.videoImage}" alt="${video.title}" class="img-fluid" />
                </a>`;
        }
        if (video.showVideo === "newtab" && video.videoType === "embed") {
            return `<a class="item-blog-post-video" target="_blank" rel="noopener noreferrer" href="${video.videoSource}">
                    <img src="${video.videoImage}" alt="${video.title}" class="img-fluid" />
                </a>`;
        }
        if (video.showVideo === "modalpopup" && video.videoType === "media") {
            return `<a class="item-blog-post-video open-video-modal" data-type="video" href="javascript:void(0);" data-video="${video.mediaLibraryVideo}" data-transcript="${video.videoTranscript}">
                    <img src="${video.videoImage}" alt="${video.title}" class="img-fluid" />
                </a>`;
        }
        if (video.showVideo === "modalpopup" && video.videoType === "embed") {
            return `<a class="item-blog-post-video open-video-modal" href="javascript:void(0);" data-type="iframe" data-video="${video.videoSource}" data-transcript="${video.videoTranscript}">
                    <img src="${video.videoImage}" alt="${video.title}" class="img-fluid" />
                </a>`;
        }
        return '';
    }


    function fetchFilteredData(topic, contentType, search) {
        
        updateComponentJQuery(false, null, null, topic, contentType, search);
    }


    function initImageCarousel() {
        var $VideoListSlider = $(".video-list-mobileitems"); 

        $VideoListSlider.each(function () {
            var $this = $(this);
            var totalSlides = $this.find('.card-wrapper').length;

            $this.on('ready.flickity select.flickity', function (event, index) {
                $this
                    .find('.card-wrapper:not(.is-selected)')
                    .attr('tabindex', '-1')
                    .end()
                    .find('.card-wrapper.is-selected')
                    .attr('tabindex', '');
            });

            if (!$this.hasClass('flickity-enabled')) {
                $this.flickity({
                    adaptiveHeight: true,
                    draggable: true,
                    pageDots: totalSlides > 1,
                    prevNextButtons: false,
                    wrapAround: false,
                    imagesLoaded: true,
                    selectedAttraction: 0.01,
                    friction: 0.15,
                    cellAlign: 'center',
                    contain: true
                });
            }

            $this.find(".dot")
                .attr('tabindex', '0')
                .keypress(function (event) {
                    if (event.keyCode == 13) {
                        $(this).click();
                    }
                });
        });        
    }

    function setEqualHeight() {
        var maxHeight = 0;
        $('.video-list-mobileitems .card-wrapper').css('height', 'auto');
        $('.video-list-mobileitems').each(function () {
            var $slider = $(this);
            var $cards = $slider.find('.card-wrapper')
            $cards.css('height', 'auto');

            $cards.each(function () {
                var thisHeight = $(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

          
            $('.video-list-mobileitems .card-wrapper').css('height', maxHeight + 'px');
        });
    }

    function changeSlideClasses(slide, method, className) {
        if (!slide) {
            return;
        }
        slide.getCellElements().forEach(function (cellElem) {
            cellElem.classList[method](className);
        });
    }

    function Youtube(Target, Source, Title) {
        var Template = "<iframe src=\"" + Source + "\" title=\"" + Title + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";
        Target.html(Template);
    }

    function Vimeo(Target, Source, Title) {
        var Template = "<iframe src=\"" + Source + "\" title=\"" + Title + "\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>";
        Target.html(Template);
    }

    function Wista(Target, Source, Title) {
        var Template = "<iframe src=\"" + Source + "\" title=\"" + Title + "\" frameborder=\"0\"  class=\"wistia_embed wistia-video\" allowtransparency=\"true\" scrolling=\"no\" name=\"wistia_embed\" allowfullscreen=\"\" mozallowfullscreen=\"\" webkitallowfullscreen=\"\" oallowfullscreen=\"\" msallowfullscreen=\"\" allow=\"fullscreen\"></iframe>"
        Target.html(Template);
    }
    $(window).on('resize', function () {
        setEqualHeight();
    });


    function setupFlickityPrototypeOnce() {
        // Use a flag to make sure this runs only once
        if (Flickity.prototype._prevNextCellsSetupDone) return;

        Flickity.createMethods.push('_createPrevNextCells');

        Flickity.prototype._createPrevNextCells = function () {
            this.on('select', this.setPrevNextCells);
        };

        Flickity.prototype.setPrevNextCells = function () {
            changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
            changeSlideClasses(this.nextSlide, 'remove', 'is-next');

            var previousI = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);
            var nextI = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);

            this.previousSlide = this.slides[previousI];
            this.nextSlide = this.slides[nextI];

            changeSlideClasses(this.previousSlide, 'add', 'is-previous');
            changeSlideClasses(this.nextSlide, 'add', 'is-next');
        };

        Flickity.prototype._prevNextCellsSetupDone = true; // mark as done
    }



    return {
        init: init
    };

})(jQuery);

$(function () {
    App.VideoList.init();
});
